"use strict";

const TouchscreenMap = () => {
    const init = () => {
        $(function () {
            
            let $mapHolder = $('.js-touchscreen-locations');

            if($mapHolder.length){
                let $map = $('.js-map');
                let lat = parseFloat($map.data('lat'));
                let lng = parseFloat($map.data('lng'));
                let pin = $map.data('pin');
                let activePin = $map.data('active-pin') !== undefined ? $map.data('active-pin') : $map.data('pin');
                let zoom = $map.data('zoom');
                let locations = $map.data('locations');
                
                let map_obj = new google.maps.Map($map[0], {
                    center: {lat, lng},
                    zoom: parseFloat(zoom),
                    disableDefaultUI: true,
                    styles: [
                        {
                            "featureType": "landscape",
                            "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "saturation": -100 }, { "lightness": 51 }, { "visibility": "simplified" }]
                        },
                        {
                            "featureType": "road.highway",
                            "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
                        },
                        {
                            "featureType": "road.arterial",
                            "stylers": [{ "saturation": -100 }, { "lightness": 30 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [{ "saturation": -100 }, { "lightness": 40 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
                            },
                        {
                            "featureType": "administrative.province",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }, { "lightness": -25 }, { "saturation": -100 }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }]
                        }
                    ]
                });

                let points = [];
                addLocationsToMap(map_obj, pin, activePin, locations, points, true);
            }

            function addLocationsToMap(map, pin, activePin, locations, points, hasClickFunction) {
                const icon = {
                    url: pin,
                    scaledSize: new google.maps.Size(37, 61),
                }

                const activeIcon = {
                    url: activePin,
                    scaledSize: new google.maps.Size(37, 61),
                }

                let i = 0;
                locations.forEach((item) => {
                    if (item.latitude && item.longitude) {
                        points[i] = new google.maps.Marker({
                            position: {
                                "lat": parseFloat(item.latitude),
                                "lng": parseFloat(item.longitude)
                            },
                            map: map,
                            icon: icon,
                        });
                        points[i]['id'] = item.id;
                        if(hasClickFunction){
                            google.maps.event.clearInstanceListeners(points[i]);
                            points[i].addListener('click', function () {
                                points.forEach((item) => {
                                    if(item.id == this.id){
                                        item.setIcon(activeIcon);
                                    }else{
                                        item.setIcon(icon);
                                    }
                                });
                                let latLng = this.getPosition();
                                map.setCenter(latLng);
                                let $listings = $('.js-map-location');
                                $listings.removeClass('active');
                                let $listing = $listings.filter('[data-id="'+item.id+'"]');
                                $listing.addClass('active');
                                let $parent = $listing.parents('.js-map-locations-holder')
                                $parent.animate({
                                    scrollTop: $parent.scrollTop() + $listing.position().top
                                }, 100);
                            });
                        }
                        i++;
                    }
                });
                
                $('.js-map-location').off('click');
                $('.js-map-location').on('click', function(){
                    let $listing = $(this);
                    let $listings = $('.js-map-location');
                    $listings.removeClass('active');
                    $listing.addClass('active');
                    points.forEach((item) => {
                        if(item.id == $listing.data('id')){
                            let latLng = item.getPosition();
                            map.setCenter(latLng);
                            item.setIcon(activeIcon);
                        }else{
                            item.setIcon(icon);
                        }
                    });
                });
            }
        });
    };

    return {
        init: init
    };
};

export default TouchscreenMap;